import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Computer} from '@material-ui/icons';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        borderRadius: '50%',
        overflow: 'hidden',
        width: '45px',
        height: '45px'
    },
    avatar: {
        width: '100%',
        height: '100%',
        flexGrow: 0,
        flexShrink: 1,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        alignSelf: 'center'
    }
});

const MachineAvatar = () => {
    const classes = useStyles();

    return (
               <div className={classes.root}>
                        <Computer className={classes.avatar}/>
        </div>
    );
};


export default MachineAvatar;
